module.exports = __webpack_public_path__ + "img/germany-cerebrovascular-disease-female.c9459b28.png";